import SearchBar from '@/ui//searchBar/primarySearchBar/SearchBar';
import HeaderMenu from './headerMenu/HeaderMenu';
import { useState, useCallback } from 'react';
import { getHotSearch } from '@/api/search';
import { useTranslation } from 'react-i18next';
import * as amplitude from '@amplitude/analytics-browser';
import { Menu } from 'lucide-react';
import MobileMenu from '../leftPannel/components/menu/MobileMenu';
import { toast } from 'sonner';
import { SheetContent, Sheet } from '@/components/ui/sheet';
import { SidebarTrigger } from '@/components/ui/sidebar';

const Header = () => {
  const [t] = useTranslation('mainframe');

  const [inputText, setInputText] = useState('');
  const [candidateList, setCandidateList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = async (event) => {
    const query = event.target.value;
    setInputText(query);
    if (query.length === 0) {
      clearStates();
      return;
    }
    setCandidateCompanies(query);
  };

  const debounce = (callback, delay) => {
    let timerId = null;
    return (...args) => {
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };

  const setCandidateCompanies = useCallback(
    debounce((query) => getCandidateCompanies(query), 300),
    [],
  );

  const getCandidateCompanies = async (q) => {
    const res = await getHotSearch(q);
    if (!isOpen) setIsOpen(true);
    setCandidateList(res.data);
  };

  const clearStates = () => {
    setInputText('');
    setCandidateList([]);
    setIsOpen(false);
  };

  const handleNavigate = (id) => {
    window.location.href = `/company/${id}`;
    clearStates();
  };

  const handleEnter = async (event) => {
    const inputValue = event.target.value;

    if (!inputValue || inputValue.length === 0) return;

    const res = await getHotSearch(inputValue);

    if (res.data && res.data.length > 0) {
      amplitude.track('search_complete', { company_code: res.data[0].corp_code });
      window.location.href = `/company/${res.data[0].corp_code}`;
    } else {
      toast.error(t('Could not find the company'));
    }
    clearStates();
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <>
      {/* Desktop */}
      <div className="absolute w-full top-5 left-1/2 -translate-x-1/2 hidden md:block z-50">
        <div className="relative left-1/2 -translate-x-1/2 max-w-[560px] w-[90vw] h-12 flex items-center justify-center translate-y-1">
          <SearchBar
            value={inputText}
            onChange={handleChange}
            onEnter={handleEnter}
            handleNavigate={handleNavigate}
            searchList={candidateList}
          />
        </div>
        <div className="absolute right-6 top-1/2 -translate-y-1/2 mt-1">
          <HeaderMenu />
        </div>
      </div>

      {/* Mobile */}
      <div className="absolute w-full top-2 left-1/2 -translate-x-1/2 md:hidden">
        <div className="relative left-1/2 -translate-x-1/2 w-[90vw] h-12">
          <SearchBar
            value={inputText}
            onChange={handleChange}
            onEnter={handleEnter}
            handleNavigate={handleNavigate}
            searchList={candidateList}
          />
        </div>
        <div className="absolute right-14 top-1/2 -translate-y-1/2 mt-0.5">
          {/* <Menu size={22} strokeWidth={1.5} onClick={() => setOpenDrawer(!openDrawer)} /> */}
          <SidebarTrigger />
        </div>
      </div>

      <Sheet open={openDrawer} onOpenChange={setOpenDrawer}>
        <SheetContent>
          <MobileMenu onClose={() => setOpenDrawer(false)} />
        </SheetContent>
      </Sheet>
    </>
  );
};

export default Header;
